import { IEventDetailsDTO } from '../../../../../../../api/events.dao';
import { IScheduledEmailDTO, ScheduledTypes } from '../../../../../../../api/scheduled-email.dao';
import { withViewModel } from '../../../../../../../infrastructure/components/with-view-model';
import { ScheduledEmailFormPresentation } from './scheduled-email-form-presentation';
import { IMeetingData, ScheduledEmailFormVM } from './scheduled-email-form.viewmodel';

export interface IScheduledEmailFormContainerProps {
    accountId: number;
    event: IEventDetailsDTO;
    type: ScheduledTypes;
    saveCompletionCallback: (data: IScheduledEmailDTO) => void;
    updateCompletionCallback: (data: IScheduledEmailDTO) => void;
    scheduledEmailDTO: IScheduledEmailDTO;
    meetingData: IMeetingData;
}

const ScheduledEmailFormContainer = withViewModel(
    ScheduledEmailFormPresentation,
    (props: IScheduledEmailFormContainerProps) => {
        const vm = new ScheduledEmailFormVM(
            props.accountId,
            props.saveCompletionCallback,
            props.updateCompletionCallback,
            props.scheduledEmailDTO,
            props.type,
            props.meetingData,
            props.event,
        );
        vm.initialize();
        return vm;
    },
    () => []);

export { ScheduledEmailFormContainer as ScheduledEmailForm };
